import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type MetricValueFieldsFragment = { __typename?: 'MetricValue', quantity: number, value: number };

export type GetRestockMetricsQueryVariables = Types.Exact<{
  sessionId: Types.Scalars['String']['input'];
  itemId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  filter?: Types.InputMaybe<Types.RestockMetricsFilterInput>;
}>;


export type GetRestockMetricsQuery = { __typename?: 'Query', restockMetrics?: { __typename?: 'RestockMetrics', utilizationPercent: number, available: { __typename?: 'MetricValue', quantity: number, value: number }, allocated: { __typename?: 'MetricValue', quantity: number, value: number }, inTransit: { __typename?: 'MetricValue', quantity: number, value: number }, availableForOrders: { __typename?: 'MetricValue', quantity: number, value: number }, onOrder: { __typename?: 'MetricValue', quantity: number, value: number }, remainingAvailability: { __typename?: 'MetricValue', quantity: number, value: number } } | null };

export const MetricValueFieldsFragmentDoc = new TypedDocumentString(`
    fragment MetricValueFields on MetricValue {
  quantity
  value
}
    `, {"fragmentName":"MetricValueFields"});
export const GetRestockMetricsDocument = new TypedDocumentString(`
    query GetRestockMetrics($sessionId: String!, $itemId: String, $filter: RestockMetricsFilterInput) {
  restockMetrics(sessionId: $sessionId, itemId: $itemId, filter: $filter) {
    available {
      ...MetricValueFields
    }
    allocated {
      ...MetricValueFields
    }
    inTransit {
      ...MetricValueFields
    }
    availableForOrders {
      ...MetricValueFields
    }
    onOrder {
      ...MetricValueFields
    }
    remainingAvailability {
      ...MetricValueFields
    }
    utilizationPercent
  }
}
    fragment MetricValueFields on MetricValue {
  quantity
  value
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetRestockMetrics: build.query<GetRestockMetricsQuery, GetRestockMetricsQueryVariables>({
      query: (variables) => ({ document: GetRestockMetricsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetRestockMetricsQuery, useLazyGetRestockMetricsQuery } = injectedRtkApi;
